import { Component, OnInit, Input, ViewChild, ElementRef, Output, EventEmitter, HostListener, Renderer2, SimpleChanges } from '@angular/core';
import { CarouselInfo } from 'app/model/carousel.model';
import { UtilitiesService } from 'app/services/utilities/utilities.service';
import { AppConfigService } from 'app/services/app-config/app-config.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'act-slide-show',
  templateUrl: './slide-show.component.html',
  styleUrls: ['./slide-show.component.scss']
})
export class SlideShowComponent implements OnInit {
  public slideIndex: number;
  public MAX_IMAGE_LENGTH: number;
  public isMobile = false;
  public images: string[];
  public mobileImages: string[];
  public langSubscription: Subscription;
  public slideItem: HTMLCollection;
  public navItem: HTMLCollection;
  public posX1 = 0;
  public posX2 = 0;
  public posInitial = 0;
  public posFinal = 0;
  public threshold = 0;

  @Input('data') data: CarouselInfo;
  @Input('isModalOpen') isModalOpen: boolean;
  @ViewChild('wrapper') wrapper: ElementRef; 
  @ViewChild('navDot') navDot: ElementRef;
  @Output() eventIndex = new EventEmitter<number>();

  constructor(
    private renderer: Renderer2,
    private appConfigService: AppConfigService,
    private utilitiesService: UtilitiesService
  ) { }

  ngOnInit() {
    this.utilitiesService.isScreenLessThan416() && (this.isMobile = true);
    this.setLangImage(this.appConfigService.getLanguage());
    this.setDefaultValue();
    this.langSubscription = this.appConfigService.getLanguageObs().subscribe((lang) => {
      this.setLangImage(lang);
    });
  }

  ngAfterViewInit(): void {
    this.showSlide(0);    
    this.renderer.listen(this.wrapper.nativeElement, 'touchstart', this.ontouchstart.bind(this));
    this.renderer.listen(this.wrapper.nativeElement, 'touchmove', this.ontouchmove.bind(this));
    this.renderer.listen(this.wrapper.nativeElement, 'touchend', this.ontouchend.bind(this));
  }

  ontouchstart(event) {
    this.posInitial = this.wrapper.nativeElement.offsetLeft;
    this.posX1 = event.touches[0].clientX;
  }

  ontouchmove(event) {
    this.posX2 = this.posX1 - event.touches[0].clientX;
    this.posX1 = event.touches[0].clientX;
    let opacityValue = Math.abs(this.wrapper.nativeElement.offsetLeft - this.posX2);
    this.renderer.setStyle(this.wrapper.nativeElement.children[this.slideIndex], 'opacity', 1-Math.floor(opacityValue)/100 + '');
  }

  normalizeValue(input: number){
    return (input-0)/1
  }

  ontouchend() {
    this.posFinal = this.wrapper.nativeElement.offsetLeft;
    if (this.posFinal - this.posInitial < - this.threshold) {
      // shift right
    } else if (this.posFinal - this.posInitial > this.threshold) {
      // shift left
    }
  }

  setLangImage(lang: string){
    if (lang === 'th') {
      this.images = this.data.imagesTh;
      this.mobileImages = this.data.mobileImagesTh;
    } else {
      this.images = this.data.imagesEn;
      this.mobileImages = this.data.mobileImagesEn;
    }
  }

  handleEvent(index: number) {
    if(!this.isModalOpen){
      this.eventIndex.emit(index);
    }
  }

  setDefaultValue(){
    this.slideIndex = 0;
    this.MAX_IMAGE_LENGTH = this.data.imagesTh.length;
    this.posX1 = 0;
    this.posX2 = 0;
    this.posInitial = 0;
    this.posFinal = 0;
    this.threshold = 100;
  }

  nextSlide() {
    this.slideIndex = this.slideIndex + 1;
    this.showSlide(this.slideIndex);
  }

  prevSlide() {
    this.slideIndex = this.slideIndex - 1;
    this.showSlide(this.slideIndex);
  }

  setImageDisplay(index: number) {
    this.showSlide(index);
  }

  showSlide(index: number) {
    if(index < 0){
      this.slideIndex = this.MAX_IMAGE_LENGTH - 1;
      index = this.slideIndex;
    }
    if(index >= this.MAX_IMAGE_LENGTH){
      this.slideIndex = 0;
      index = this.slideIndex;
    }
    const activeSlideElement = this.wrapper.nativeElement.querySelector('.activeSlide');
    const activeNavDotElement = this.navDot.nativeElement.querySelector('.active');
    if (activeSlideElement) {
      this.renderer.removeClass(activeSlideElement, 'activeSlide');
    }
    if (activeNavDotElement) {
      this.renderer.removeClass(activeNavDotElement, 'active');
    }
    this.renderer.addClass(this.wrapper.nativeElement.children[index], 'activeSlide');
    this.renderer.addClass(this.navDot.nativeElement.children[index], 'active');
  }

  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.isMobile = this.utilitiesService.isScreenLessThan416();
    if(this.isMobile){
      this.showSlide(this.slideIndex);
    }
  }

}


// WEBPACK FOOTER //
// ./src/app/components/slide-show/slide-show.component.ts